import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';

export interface PAYGUserCreditsProps {
  isImageBGREnabled: boolean | null;
  isVideoBGREnabled: boolean | null;
  imageBGRCredits: number | null;
  videoBGRCredits: number | null;
  isLoading: boolean;
}

const initialState: PAYGUserCreditsProps = {
  isImageBGREnabled: null,
  isVideoBGREnabled: null,
  imageBGRCredits: null,
  videoBGRCredits: null,
  isLoading: false,
};

export const paygUserCreditsSlice = createSlice({
  name: 'paygUserCredits',
  initialState,
  reducers: {
    initPAYGUserCredits: (state, action: PayloadAction<PAYGUserCreditsProps>) => {
      state.isImageBGREnabled = action.payload.isImageBGREnabled;
      state.isVideoBGREnabled = action.payload.isVideoBGREnabled;
      state.imageBGRCredits = action.payload.imageBGRCredits;
      state.videoBGRCredits = action.payload.videoBGRCredits;
      state.isLoading = false;
    },
    updatePAYGUserImageBGRCredits: (state, action: PayloadAction<number>) => {
      state.imageBGRCredits = action.payload;
    },
    updatePAYGUserVideoBGRCredits: (state, action: PayloadAction<number>) => {
      state.imageBGRCredits = action.payload;
    },
    updateIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const {initPAYGUserCredits, updatePAYGUserImageBGRCredits, updatePAYGUserVideoBGRCredits, updateIsLoading} = paygUserCreditsSlice.actions;
export const paygUserCreditsReducer = paygUserCreditsSlice.reducer;
